exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adPrice__price___2QFxe {\n  color: #f94144;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 36px;\n  display: inline-block;\n  white-space: nowrap; }\n\n.adPrice__prevPrice___39_iW {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 24px;\n  text-align: left;\n  text-decoration-line: line-through;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none; }\n", ""]);

// exports
exports.locals = {
	"price": "adPrice__price___2QFxe",
	"prevPrice": "adPrice__prevPrice___39_iW"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/SimilarAdCard/AdSummary/AdPrice/adPrice.scss
// module id = 4134
// module chunks = 6